import lottie from 'lottie-web';

const text = document.querySelector('.grid__subtitle');

let textAnimate = lottie.loadAnimation({
	container: text,
	renderer: 'svg',
	loop: false,
	autoplay: false,
	path: '../data/text.json',
});

const init = () => {
	textAnimate.playSegments([0], true);
};

export default {
	init,
};
